// extracted by mini-css-extract-plugin
module.exports = {"DesktopMenu":"DesktopMenu_DesktopMenu__i4Bel","ClosedItems":"DesktopMenu_ClosedItems__avh_j"};